module.exports = __webpack_public_path__ + "img/bamboo.b9be46ed.jpg";